import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faAngleRight } from '@fortawesome/pro-regular-svg-icons';
import Inset from 'syf-component-library/ui/spacing/Inset';
import { getFormattedDate } from '../../../helpers/promotions-utils';
import useTranslation from '../../../hooks/use-translation';
import { StyledText } from '../../../styles/text';
import { colors } from '../../../styles/theme';
import FontAwesomeComponent from '../../common/font-awesome-component';
import PromotionsTooltip from '../tooltip';
import { StyledCard, StyledCardButton, StyledLineItem } from './subcomponents';
const Card = ({ promotion, showDetailsModal }) => {
    const t = useTranslation();
    const { description, purchaseDate, purchaseAmount, unbilledInterest, remainingBalance, expirationDate } = promotion;
    const formattedPurchaseDate = getFormattedDate({ date: purchaseDate });
    const formattedExpirationDate = getFormattedDate({
        date: expirationDate,
        expirationDateLabel: t('promotions.untilPaidOffCellValue')
    });
    const cardData = [
        {
            text: t('promotions.purchaseDateCellValue'),
            value: formattedPurchaseDate
        },
        {
            text: t('promotions.purchaseAmountDateCellValue'),
            value: `$${purchaseAmount}`
        },
        {
            text: t('promotions.deferredInterestChargesCellValue'),
            value: `$${unbilledInterest}`
        },
        {
            text: t('promotions.promotionalBalanceHeader'),
            value: `$${remainingBalance}`,
            tooltip: _jsx(PromotionsTooltip, {})
        },
        {
            text: t('promotions.expirationDateCellValue'),
            value: formattedExpirationDate
        }
    ];
    const handleOnKeyDown = (evt) => {
        if (evt.code === 'Enter') {
            showDetailsModal(promotion);
        }
    };
    return (_jsxs(StyledCard, { top: "large", vertical: "large", bottom: "base", children: [_jsx(Inset, { bottom: "base", children: _jsxs(StyledCardButton, { fontSize: "large", fontWeight: "light", textAlign: "left", onClick: () => showDetailsModal(promotion), onKeyDown: handleOnKeyDown, children: [_jsx("span", { children: description }), _jsx(FontAwesomeComponent, { title: "View promotion details", icon: faAngleRight, color: colors.cyanBlue })] }) }), _jsx("dl", { children: cardData.map(data => (_jsxs(StyledLineItem, { justifyContent: "space-between", children: [_jsxs("dt", { children: [data.text, " ", data.tooltip] }), _jsx(StyledText, { as: "dd", weight: "bold", children: data.value })] }, `${data.value}-${data.text}`))) })] }));
};
export default Card;
//# sourceMappingURL=index.js.map